import type { OsVersionResourceListResponseV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import { enumVersionPublicationStatus } from '@ingenico/api-sdk-device-management-private-v2';
import { isEqual, toString } from 'lodash-es';
import type { OsVersionList } from '../../../../pages/os-application-details-page/OSApplicationDetailsPage.model';
import { VersionStatus } from '../../../../pages/os-application-details-page/OSApplicationDetailsPage.model';

export function mapOsVersionByOsId({ data, pagination }: OsVersionResourceListResponseV2Api): OsVersionList {
  const dataDto = data.map(({ creationDate, versionNumber, status, id }) => ({
    version: toString(versionNumber),
    creationDate: creationDate ?? '',
    status: isEqual(status, enumVersionPublicationStatus.PUBLISHED)
      ? VersionStatus.PUBLISHED
      : VersionStatus.DEPRECATED,
    id: toString(id),
  }));

  return {
    data: dataDto,
    pagination,
  };
}
